import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const EMERGENCY_AUTO_GLASS_FAQS = [{
  question: 'Do you offer emergency auto glass near me?',
  answer: "Kosin's Glass serves Howell, Ann Arbor, Novi and surrounding Southeast Michigan communities. Call or request an urgent quote and the team will confirm today's availability for your vehicle and glass type."
}, {
  question: 'Can I get same-day windshield replacement?',
  answer: 'Same-day openings may be available depending on your vehicle, glass availability, insurance details and the schedule. Call 517-545-7772 to check the fastest available option.'
}, {
  question: 'My windshield is cracked. Is it safe to drive?',
  answer: "If the crack blocks your view, is spreading, is near the windshield edge, or makes the vehicle feel unsafe, do not continue driving. Call Kosin's Glass for guidance on the safest next step."
}, {
  question: 'Can a broken windshield be repaired today?',
  answer: "Small chips may be repairable if they are contained, away from the driver's line of sight and away from the windshield edge. Cracks are generally not repairable and usually require replacement."
}, {
  question: 'Do you replace shattered side windows and rear windows?',
  answer: "Yes. Kosin's Glass replaces side windows, driver and passenger door glass, power window glass, quarter glass and rear vehicle glass."
}, {
  question: "Can Kosin's Glass help with insurance?",
  answer: "Yes. Kosin's Glass works with most insurance companies and can help with quote details, claim coordination and scheduling."
}, {
  question: 'Will I need ADAS calibration after emergency windshield replacement?',
  answer: "If your vehicle has a forward-facing camera or driver-assistance sensors near the windshield, calibration may be required after replacement. Kosin's Glass offers on-site ADAS calibration."
}, {
  question: 'What information should I have ready when I call?',
  answer: 'Have your vehicle year, make, model, which glass is damaged, a photo if possible, insurance information and your best callback number ready.'
}, {
  question: 'Do you repair truck, van, fleet or semi-truck glass?',
  answer: "Yes. Kosin's Glass handles auto glass for cars, trucks, vans, fleet vehicles and semi trucks. Availability depends on the vehicle and glass needed."
}, {
  question: 'Are you open on weekends?',
  answer: "Kosin's Glass is open Monday through Friday from 8:00 a.m. to 5:00 p.m. and Saturday from 9:00 a.m. to 3:00 p.m. Sunday is closed."
}];
export function EmergencyAutoGlassFAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-418" data-mp="2i4hswtztb4px">
      <div className="max-w-3xl mx-auto" data-id="element-419" data-mp="2i25eurx6dei5">
        <div className="text-center mb-12" data-id="element-420" data-mp="2n2t00wyq314g">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-4 tracking-normal leading-tight" data-id="element-421" data-mp="2n1i0j9cb8fj5">
            <span className="text-emergencyBrand-red" data-id="element-422" data-mp="145vncl2po7ke">
              Emergency Auto Glass
            </span>{' '}
            Questions
          </h2>
        </div>
        <div className="space-y-4" data-id="element-423" data-mp="v5ytm51gsiih">
          {EMERGENCY_AUTO_GLASS_FAQS.map((item, idx) => {
          const isOpen = openIdx === idx;
          const panelId = `emergency-faq-panel-${idx}`;
          const buttonId = `emergency-faq-button-${idx}`;
          return <div key={idx} className={`border rounded-lg transition-colors ${isOpen ? 'border-emergencyBrand-redBorder bg-emergencyBrand-redLight/40' : 'border-slate-200 bg-white'}`} data-id="element-424" data-mp="ghkti1vfn85m" data-mpi={idx}>
                <button type="button" id={buttonId} aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIdx(isOpen ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-emergencyBrand-red rounded-lg" data-id="element-425" data-mp="7jsb2ouezke0">
                  <span className="text-lg font-bold text-slate-900 pr-8" dangerouslySetInnerHTML={{
                __html: item.question
              }} data-id="element-426" data-mp="1nw7oll3owjme" />
                  <ChevronDown className={`w-6 h-6 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-emergencyBrand-red' : 'text-slate-400'}`} aria-hidden="true" data-id="element-427" data-mp="1ev9t5r7bhkff" />
                </button>
                <div id={panelId} role="region" aria-labelledby={buttonId} className={`grid transition-[grid-template-rows] duration-300 ease-out ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-428" data-mp="19wgcxr0nbfbk">
                  <div className="overflow-hidden" data-id="element-429" data-mp="3483ia7h5yy67">
                    <div className="px-6 pb-6 text-slate-600 text-lg leading-relaxed" dangerouslySetInnerHTML={{
                  __html: item.answer
                }} data-id="element-430" data-mp="snw0arrxp66j" />
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}